import React from 'react';
import InfoBarBase from './InfoBarBase';
export default class InfoBar extends React.Component {
  render() {
    const { total, page, pages} = this.props;
    let show = false;
    if (total >= 0 && page >= 0 && pages >= 0) {
      show = true;
    }
    if (total === 0) {
      show = false;
    }
    const data = [];

    data.push({ title: 'Total Records', value: show && total.toLocaleString() });
    data.push({ title: 'Current Page', value: show && page.toLocaleString() });
    data.push({ title: 'Total Pages', value: show && pages.toLocaleString() });

    return (
      <InfoBarBase data={data} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/InfoBar.js